import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "./sys";
import { TargetingSchema, TargetingFragment } from "./targeting";
import { RelatedMediaSchema, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedSpotlightSchema,
  LocalizedSpotlightFragment,
} from "./newsEntryTypes/localizedSpotlight";
import {
  CarouselEventPollEntrySchema,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";
import {
  CarouselEventProgressTrackerEntrySchema,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";
import {
  EsportCarouselLiveEntrySchema,
  EsportCarouselLiveEntryFragment,
} from "./newsEntryTypes/esportCarouselLiveEntry";

export const EsportSpotlightSchema = z.object({
  __typename: z.literal("EsportSpotlight"),
  sys: SysSchema,
  sortDate: z.string().nullable(),
  newUntil: z.string().nullable(),
  size: z.enum(["small", "medium", "large"]).nullable(),
  video: z.string().nullable(),
  enableVideoSound: z.boolean().nullable().default(false),
  targeting: TargetingSchema.nullable(),
  relatedMedia: RelatedMediaSchema.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      EsportCarouselLiveEntrySchema,
      LocalizedSpotlightSchema,
      CarouselEventPollEntrySchema,
      CarouselEventProgressTrackerEntrySchema,
    ])
    .nullish(),
});

export const EsportSpotlight = EsportSpotlightSchema;
export type EsportSpotlight = z.infer<typeof EsportSpotlightSchema>;

export const EsportSpotlightFragment = gql`
  fragment EsportSpotlightFragment on EsportSpotlight {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    newUntil
    sortDate
    size
    video
    enableVideoSound
    localized {
      ... on EsportLiveEventEntry {
        ...EsportCarouselLiveEntryFragment
      }
      ... on LocalizedSpotlight {
        ...LocalizedSpotlightFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }
  ${SysFragment}
  ${EsportCarouselLiveEntryFragment}
  ${LocalizedSpotlightFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
